export const getInitialValues = (shiptos, userLocationsPreferences) => {
    let initialValues = {
        all: false,
    }
    let selectedShiptosCount = 0
    shiptos?.forEach(s => {
        const exists =
            userLocationsPreferences?.find(l => l?.id == s?.id) !== undefined
        if (exists) {
            selectedShiptosCount++
        }
        initialValues[s?.id] = exists
    })

    return {
        ...initialValues,
        all: selectedShiptosCount === shiptos?.length,
    }
}
